import { Injectable } from '@angular/core';
import {catchError, Observable, retry} from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HelperService} from "../../helper.service";
import {BaseService} from "../../services/base.service";
import {CustomerModel} from "../models-otc/customer-model";
import {CustomerAltAddressDto} from "../dto-otc/customer-alt-address-dto";
import {CustomerAltAddressModel} from "../models-otc/customer-alt-address-model";
@Injectable({
    providedIn: 'root'
})
export class CustomerService extends BaseService{
    userId = this.helper.getUserId();
    constructor(
        private httpClient: HttpClient,
        public snackBar: MatSnackBar,
        public helper: HelperService,
    ) {
        super();
    }


    /// GET  ///
    getCustomerDetails(): Observable<CustomerModel[]> {

        let headers = new HttpHeaders({
            'userId': String(this.userId)
        });

        return this.httpClient.get<CustomerModel[]>(this.OTC_BASE_URL + 'customers', {headers: headers})
            .pipe(
                retry(1),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Order Form Details','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    getCustomerDetailsByPriceList(soldToId:number): Observable<CustomerModel[]> {

        let headers = new HttpHeaders({
            'userId': String(this.userId),
        });

        return this.httpClient.get<CustomerModel[]>(this.OTC_BASE_URL + `customers/pricelist/${soldToId}`, {headers: headers})
            .pipe(
                retry(1),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Order Form Details','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    /// POST ///
    postNewCustomerAltAddress(customerAltAddressDto: CustomerAltAddressDto, tenantId:number): Observable<CustomerAltAddressModel> {
        return this.httpClient.post<CustomerAltAddressModel>(this.OTC_BASE_URL + `address/${tenantId}/altaddress`,customerAltAddressDto)
            .pipe(
                retry(1),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Creating New Alternative Address','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }
}
